import { render, staticRenderFns } from "./ConfiguracaoMaterial.vue?vue&type=template&id=0d6725b3&lang=pug"
import script from "./ConfiguracaoMaterial.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoMaterial.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracaoMaterial.vue?vue&type=style&index=0&id=0d6725b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports